@if (vendorsQuery.loading() || loading()) {
  <ng-template #loader>
    <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
  </ng-template>
  <ng-container [ngTemplateOutlet]="loader" />
} @else {
  <div class="flex w-full items-center justify-between">
    <div class="text-2xl font-bold">Vendor Contracts</div>
    <div class="flex items-center space-x-4">
      <aux-button
        [disabled]="ctx.disabledUI()"
        [auxTooltip]="ctx.vendorActionTooltip()"
        variant="secondary"
        label="Add New Vendor Contract"
        [onClick]="onNewVendor"
        icon="Plus"
      />
      <aux-button
        [disabled]="ctx.disabledUI()"
        [auxTooltip]="ctx.vendorActionTooltip()"
        variant="secondary"
        label="Add Multiple Vendor Contracts"
        [onClick]="onAddMultipleVendors"
        icon="Plus"
      />
    </div>
  </div>

  <div class="mt-4 flex w-full flex-wrap pb-4">
    <div class="mb-8 w-full">
      <ag-grid-angular
        class="ag-theme-aux vendor-table tabular-nums"
        domLayout="autoHeight"
        id="VendorsGrid"
        [rowData]="gridData$ | async"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (gridSizeChanged)="sizeColumnsToFit()"
        (firstDataRendered)="onFirstDataRendered()"
        auxStickyGrid
      />
      <aux-pagination-panel
        [gridApi]="gridAPI!"
        [paginationPageSize]="gridOptions.paginationPageSize"
        (paginationChange)="onPaginationChange()"
      />
    </div>
  </div>
}
